import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { HelpeContext } from '../contexts';

function HelpeProvider({ children }) {
  const [showHelpeIcon, setShowHelpeIcon] = useState(true);
  const obj = useMemo(
    () => ({ showHelpeIcon, setShowHelpeIcon }),
    [showHelpeIcon],
  ); // value is cached by useMemo

  return <HelpeContext.Provider value={obj}>{children}</HelpeContext.Provider>;
}

HelpeProvider.propTypes = {
  children: PropTypes.object,
};

export default HelpeProvider;
